<template lang="pug">
  .maptalks-label
    slot(v-if='ready')
</template>

<script>
import * as TWEEN from '@tweenjs/tween.js'
import requestSmoothAnimation from '@/utils/requestSmoothAnimation'
import { createLabel } from '@/utils/map'
import { MAP_MOVE_INTERVAL } from '@/app.config'

const animate = () => {
  if (TWEEN.update()) {
    requestSmoothAnimation(animate)
  }
}

export default {
  name: 'maptalks-label',
  props: {
    coordinates: {
      type: [Object, Array],
      required: true
    },
    options: {
      type: Object,
      default: () => ({
        symbol: {}
      })
    },
    textFill: {
      type: String,
      default: '#fff'
    },
    textName: {
      type: String,
      default: 'text name'
    }
  },
  methods: {
    move ({ oldPosition: [ oldX, oldY ], newPosition: [ newX, newY ] }) {
      const from = {
        x: oldX,
        y: oldY
      }
      const to = {
        x: newX,
        y: newY
      }
      new TWEEN.Tween(from)
        .to(to, MAP_MOVE_INTERVAL)
        .easing(TWEEN.Easing.Quadratic.InOut)
        .onUpdate(({ x, y }) => {
          this.mapObject.setCoordinates([ x, y ])
        })
        .start()

      animate()
    }
  },
  watch: {
    coordinates (newValue, oldValue) {
      if (!this.mapObject) return
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return

      this.move({
        newPosition: newValue,
        oldPosition: oldValue
      })
    }
  },
  data () {
    return {
      ready: false,
      mapObject: null
    }
  },
  mounted () {
    const vectorLayer = this.$parent.mapObject

    const label = createLabel({
      label: this.textName,
      coordinates: this.coordinates,
      options: {
        boxStyle: {
          padding: [5, 4],
          symbol: {
            markerType: 'square',
            markerFill: '#000',
            markerFillOpacity: 0.5,
            markerLineWidth: 0
          }
        },
        textSymbol: {
          textSize: 10,
          textWeight: 'bold',
          textVerticalAlignment: 'middle',
          textDy: -20,
          textFill: this.textFill
        }
      }
    })

    label.addTo(vectorLayer)

    this.mapObject = label
    this.ready = true
  },
  beforeDestroy () {
    this.mapObject.remove()
  }
}
</script>

<style scoped>
.maptalks-label {
  display: none;
}
</style>
